import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useSessionMetadata } from '@/hooks/useSessionMetadata'
import { USER_TYPE } from '@/types/misc'
import { SessionMetadataUser } from '@/types/responses/session-metadata'

export function useCurrentClientUser(): SessionMetadataUser | undefined {
  const sessionMetadata = useSessionMetadata()
  const currentUser = useCurrentUser()

  return currentUser && sessionMetadata?.currentUserType === USER_TYPE.client
    ? currentUser
    : undefined
}
